import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { reduxForm, getFormValues } from 'redux-form';
import { fetchIncomeTaxDeclarationList, getIncomeTaxDeclarationList } from 'src/reducers/reports/incomeTaxDeclarations';
import { takeIncomeTaxDeclarationsSearchQueriesFromLocation, takeIncomeTaxDeclarationsResetFormQueries } from 'src/reducers/searchForm';

import IncomeTaxDeclarationListPage from './components/IncomeTaxDeclarationListPage';

const FORM_NAME = 'incomeTaxDeclarationSearchForm';

const IncomeTaxDeclarationList = ({ initialValues: formValues, declarations, location, fetchList, resetValues }) => (
  <IncomeTaxDeclarationListPage declarations={declarations} formValues={formValues} location={location} onSearch={fetchList} resetValues={resetValues} />
);

const mapStateToProps = state => ({
  initialValues: {
    ...takeIncomeTaxDeclarationsSearchQueriesFromLocation(state.router.location),
    ...getFormValues(FORM_NAME)(state)
  },
  declarations: getIncomeTaxDeclarationList(state),
  location: state.router.location,
  resetValues: takeIncomeTaxDeclarationsResetFormQueries(state)
});

const mapDispatchToProps = dispatch => ({
  fetchList: queries => dispatch(fetchIncomeTaxDeclarationList(queries))
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  reduxForm({
    form: FORM_NAME,
    enableReinitialize: true
  })
)(IncomeTaxDeclarationList);
